/**
 * Dynamically create everything necessary for hawksearch to work on category
 */
export const bootstrapHawksearch = async () => {
	await import('../components/search-app');
};

